import { render, staticRenderFns } from "./NewsDetailPage.vue?vue&type=template&id=4a9f7798&scoped=true"
import script from "./NewsDetailPage.vue?vue&type=script&lang=js"
export * from "./NewsDetailPage.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailPage.vue?vue&type=style&index=0&id=4a9f7798&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9f7798",
  null
  
)

export default component.exports